import { LazyLoad } from 'app/utils';

export const UserTagFormPage = LazyLoad(
  () => import('./index'),
  (module) => module.UserTagFormPage,
);
